export default __webpack_public_path__ + "static/media/ac14.dee94a5e.png";